import CertificateService from './CertificateService.js';

export default CertificateService;